import React from "react";
import cn from "classnames";
import { css } from "@emotion/react";
import { CSS_SPACER_SIZES } from "../../styles/styles-css-variables";

export const IconWithTextElementWrapper: React.FC<React.PropsWithChildren<{ noSpacing?: boolean }>> = props => {
  return (
    <div
      className={cn({ "no-spacing": !!props.noSpacing })}
      css={css`
        padding-top: ${CSS_SPACER_SIZES.md};

        &.no-spacing {
          padding-top: 0;
        }

        display: flex;
        flex-direction: column;
        align-items: center;
      `}
    >
      {props.children}
    </div>
  );
};
